// extracted by mini-css-extract-plugin
export default {"stats":"SellerConfirmationVehicle__stats-cB_j"};